export default {
  SET_VISIBILITY_STATE(state, data) {
    state.visibilityState = data
  },
}
